import { createSelector } from 'reselect';
import { getEntry } from 'conversations-async-data/indexed-async-data/operators/getters';
import getTicketData from './getTicketData';
const getThreadIdFromProps = (_, {
  threadId
}) => threadId;
export const getAsyncTicketData = createSelector([getTicketData, getThreadIdFromProps],
// @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'unknown' is not assignable to pa... Remove this comment to see the full error message
(ticketData, threadId) => getEntry(threadId, ticketData));